import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BaseResourceRptComponent, Coluna, EddyAutoComplete, LicitacaoPipe, Modalidade } from "eddydata-lib";
import { ModalidadeService } from "../../modalidade/service/modalidade.service";
import { RcmsService } from "../../rcms/service/rcms.service";

@Component({
  selector: 'lib-rcms-licitacao-rpt',
  templateUrl: './rcms-licitacao-rpt.component.html'
})
export class RcmsLicitacaoRptComponent extends BaseResourceRptComponent {


  @Input() visualizar: boolean = false;
  @Output() visualizarChange: EventEmitter<boolean> = new EventEmitter();

  public parametros: { session?: any, filtros?: any } = {};

  public pesquisa: 'P' | 'D' | 'L' | 'M' | 'TM' = 'TM';

  public processo: string = '';
  public licitacao: string = '';
  public modalidade: Modalidade;
  public data_inicio: Date = new Date();
  public data_fim: Date = new Date();

  protected datepipe: DatePipe;
  public modalidadeAutoComplete: EddyAutoComplete<Modalidade>;

  constructor(
    private rcmsService: RcmsService,

    private modalidadeService: ModalidadeService
  ) {
    super();
  }

  protected afterInit(): void {
    this.datepipe = new DatePipe('pt');
    this.formato = 'pdf';
    this.orientacao = 'landscape';

    this.carregarAutoComplete();
  }

  protected obterColunasRelatorio(): Coluna[] {
    let retorno: Coluna[] = [];
    retorno.push({ titulo: 'Licitação', coluna: 'licitacao.numero', alignment: 'left', tipo: 'Number', agrupar: true, adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'Nº REQUISIÇÃO', coluna: 'numero', alignment: 'center', tipo: 'Number', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'DATA', coluna: 'data_rcms', tipo: 'Date', alignment: 'center', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'FICHA', coluna: 'ficha.numero', alignment: 'center', tipo: 'Number', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'DESPESA', alignment: 'center', coluna: 'ficha.despesa.codigo', tipo: 'Number', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'RECURSO', coluna: 'ficha.recurso.codigo', alignment: 'center', tipo: 'Number', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'MODALIDADE', alignment: 'left', coluna: 'modalidade.nome', tipo: 'String', adicionaisBody: { border: [false, false, false, false] } });
    // retorno.push({ titulo: 'RAZÃO SOCIAL', coluna: 'favorecido.nome', alignment: 'left', tipo: 'String', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'SUB-ELEMENTO', coluna: 'subelemento.nome', alignment: 'left', tipo: 'String', adicionaisBody: { border: [false, false, false, false] } });
    retorno.push({ titulo: 'MENOR PREÇO GLOBAL', coluna: 'menor_preco_global', alignment: 'right', tipo: 'Number', decimais: 2, adicionaisBody: { border: [false, false, false, false] } });
    retorno = retorno.map((r) => {
      r.adicionaisHeader = { margin: 3 };
      return r;
    })
    return retorno;
  }

  public obterColunasfiltroPersonalizado(): Coluna[] {
    const retorno: Coluna[] = [];
    retorno.push({ titulo: 'Nº Processo', coluna: 'processo', tipo: 'String', mask: [{ mask: '0000/0000' }, { mask: '00000/0000' }], notUnmask: true, padrao: true, cols: 6 });
    retorno.push({ titulo: 'Nº Licitação', coluna: 'licitacao.numero', tipo: 'String', mask: [{ mask: '00000/0000' }], padrao: true, cols: 6 });
    retorno.push({ titulo: 'Período', coluna: 'data_rcms', tipo: 'Date', padrao: true, filtro2: new Date(), cols: 12 });
    retorno.push({
      titulo: 'Modalidade', coluna: 'modalidade.id', tipo: 'AutoComplete',
      autocomplete: new EddyAutoComplete(null, this.modalidadeService, 'id', ['nome'], { 'cidade.id': this.login.cidade.id, orderBy: 'codigo' }, { text: ['nome'], number: ['codigo'] }, null, -1),
      padrao: true, cols: 12
    });

    return retorno;
  }

  public validar(): boolean {
    return true;
  }

  protected tituloRelatorio(): string {
    return `LISTAGEM GERAL DE REQUISIÇÕES DE COMPRA POR LICITAÇÃO`;
  }

  protected larguraColunas(): (string | number)[] {
    return [70, 'auto', 'auto', 'auto', 'auto', '*', '*', 100];
  }

  protected totalizarColunas(): (string | {})[] {
    return [{ nome: 'menor_preco_global', abaixo: true }];
  }

  public imprimir(): void {
    if (!this.validar())
      return null;
    return super.imprimir();
  }

  protected carregarLista(): Promise<any[]> {
    return new Promise<any[]>((resolve) => {
      let parametros = { 'orgao.id': this.login.orgao.id, 'exercicio.id': this.login.exercicio.id, 'licitacao.id$not_null': true.valueOf, relations: 'ficha.despesa,ficha.recurso,subelemento,modalidade', orderBy: 'licitacao.numero$ASC,data_rcms$ASC' };

      if (this.parametros?.filtros)
        parametros = Object.assign(parametros, this.parametros.filtros);
      // switch (this.pesquisa) {
      //   case 'P':
      //     parametros['processo'] = this.processo;
      //     break;
      //   case 'L':
      //     parametros['licitacao.numero'] = this.licitacao;
      //     break;
      //   case 'M':
      //     parametros['modalidade.id'] = this.modalidade.id;
      //     break;
      //   case 'D':
      //     if (this.data_inicio)
      //       parametros['data_rcms$ge'] = this.funcaoService.converteDataSQL(this.data_inicio);
      //     if (this.data_fim)
      //       parametros['data_rcms$le'] = this.funcaoService.converteDataSQL(this.data_fim);
      //     break;
      // }

      this.rcmsService.extendido(0, -1, parametros)
        .subscribe((data) => {
          if (!data?.content)
            resolve(null);
          else
            resolve(data.content.map((c) => {
              c.licitacao.numero = new LicitacaoPipe().transform(c.licitacao.numero);
              if (c.subelemento?.nome)
                c.subelemento.nome = `${c.subelemento.codigo} - ${c.subelemento.nome}`;
              return c;
            }));
        })
    });
  }

  protected layout(): {} {
    return {
      hLineWidth() {
        return 1;
      },
      vLineWidth(i, node) {
        return 1;
      },
      hLineColor(i) {
        return i === 1 || i === 0 ? 'black' : '0aaa';
      },
      paddingLeft(i) {
        return 2;
      },
      paddingRight(i, node) {
        return 2;
      }
    }
  }


  private carregarAutoComplete() {
    this.modalidadeAutoComplete = new EddyAutoComplete(null, this.modalidadeService, 'id', ['nome'], { 'cidade.id': this.login.cidade.id, orderBy: 'codigo' }, { text: ['nome'], number: ['codigo'] }, null, -1);
  }

  public show() {
    this.visualizar = true;
    this.visualizarChange.emit(this.visualizar);
  }

  public hide() {
    this.visualizar = false;
    this.visualizarChange.emit(this.visualizar);
  }
}